import { isEmpty, pageLoadTime } from 'utils/browserHelper'
import Clevertap from 'analytics'
import { dayDiff, getFormattedDate } from 'utils/dateHelper'
import { DOMAIN_COUNTRY_MAP } from 'constants/flightResults'
import { DOMAIN } from 'constants/base'

export const clevertapPageLoad = ({
    urlParam,
    resultsData,
    rResultMetaData,
    currencies,
    userData,
    getAbTest,
    initialLoadTime,
    additionalData = {} ,
    absrp
}) => {
    const {
        from,
        to,
        airline,
        adults,
        childs,
        infants,
        depart_date,
        return_date,
        class: travelClass,
        utm_source
    } = urlParam
    const { jsons, filterData, cards,sid = '' } = resultsData
    let {
        expiredSuppliers,
        searchType: { WPStatus, multiCity, isIntl = false }
    } = jsons
    const {
        nbAirportFilter = [],
        oneWayPrice: { min: minOWPrice, max: maxOWPrice }
    } = filterData
    const nbAirportsLen = !isEmpty(nbAirportFilter) && (nbAirportFilter[0]?.options?.length || 0 )

    // Calculate non-stop flights
    let nonStopFlights = 0
    cards.forEach(trip => {
        trip.forEach(flight => {
            if (flight.maxStopsInSectors === 0) {
                nonStopFlights += 1
            }
        })
    })
    const tripView = cards.length === 1 ? 'solution' : cards.length === 2 ? 'split' : 'na'
    if (expiredSuppliers !== null && typeof expiredSuppliers === 'object') {
        expiredSuppliers = Object.keys(expiredSuppliers).toString()
    } else expiredSuppliers = ''

    // if (typeof newrelic == 'object') {
    //     newrelic.addPageAction('Air_performance', {
    //         result: 'sucess',
    //         page_name: 'flights_srp',
    //         origin: from,
    //         destination: to,
    //         page_load_time: new Date().getTime() - initialLoadTime || 'N/A',
    //         dx: dayDiff(new Date(getFormattedDate(depart_date, 'MM/DD/YYYY', 'DD/MM/YYYY')), new Date()),
    //         is_CFW_User: WPStatus,
    //         dom_intl: isIntl ? 'International' : 'Domestic'
    //     })
    // }
    let payload = {
        page_name: 'flights_srp',
        last_page_name: 'flights_home',
        search_id: sid,
        page_load_time: new Date().getTime() - initialLoadTime || 'N/A',
        origin: from,
        destination: to,
        origin_name: resultsData?.jsons?.ap[from]?.c,
        destination_name: resultsData?.jsons?.ap[to]?.c,
        origin_destination: `${resultsData?.jsons?.ap[from]?.c}_${resultsData?.jsons?.ap[to]?.c}`,
        airline,
        dx: dayDiff(new Date(getFormattedDate(depart_date, 'MM/DD/YYYY', 'DD/MM/YYYY')), new Date()),
        journey_type: multiCity ? 'Multi-city' : !isEmpty(return_date) ? 'RoundTrip' : 'One-way',
        dom_intl: isIntl ? 'International' : 'Domestic',
        adult_count: adults,
        child_count: childs,
        infant_count: infants,
        departure_date: depart_date,
        return_date,
        stay_duration: return_date
            ? dayDiff(
                  new Date(getFormattedDate(return_date, 'MM/DD/YYYY', 'DD/MM/YYYY')),
                  new Date(getFormattedDate(depart_date, 'MM/DD/YYYY', 'DD/MM/YYYY'))
              )
            : 'NA',
        domain: window.location.host,
        source: 'web',
        language: window.location.href.includes('/ar/') ? 'ar' : 'en',
        is_logged_in: userData.isLoggedIn ? 'yes' : 'no',
        userPrefCurrency: currencies.utmCurrency,
        is_Bento_User: 'yes',
        non_stop_flights: nonStopFlights,
        result_count: rResultMetaData.totalTuppleCount,
        travel_class: travelClass,
        srp_entry_source: utm_source || 'flights_home',
        nearby_airports: nbAirportsLen,
        expired_supplier: expiredSuppliers,
        round_trip_view: tripView,
        min_price: minOWPrice,
        max_price: maxOWPrice,
        is_CFW_User: WPStatus,
        master_tupple: getAbTest.master_tuple,
        tk_home_abcookie: absrp,
        ...additionalData
    }
    Clevertap.event('Air_PageLoad', payload)
}

export const homePageLoad = ({ initialLoadTime, getAbTest = {}, abhome, abWallet }) => {
    Clevertap.event('Air_PageLoad', {
        page_name: 'flights_home',
        is_Bento_User: 'yes',
        last_event_type: -1,
        last_page_name: -1,
        page_load_time: new Date().getTime() - initialLoadTime || 'N/A',
        tk_home_abcookie: abhome,
        wallet_display_abcookie: abWallet
    })
}
